import { render } from "./ArrowLeft.svg?vue&type=template&id=15c54cca"
const script = {}
script.render = render

export default script